module.exports = __webpack_public_path__ + "img/102018.01aebb53.png";